module.exports = __webpack_public_path__ + "static/media/best-company-award.aefdce75.svg";